/**
 * Crea los valores de todas las variables simples
 * @param {*} scene - Escena actual de Phaser
 */
export function crearVariables(scene) {
  scene.apuestaTotal = 0; // Apuesta total del jugador al iniciar la ruleta
  scene.ultimaApuestaTotal = 0; // Ultima apuesta total realizada por el jugador
  scene.premioTotal = 0; // Premio total del jugador al iniciar la ruleta
  scene.valorUltimaApuesta = 0; // Valor de la última apuesta realizada
  scene.ultimaFichaColocada = 0; // Valor de la última ficha colocada
  scene.ultimaFichaDeApuesta = 0; // Valor de la última ficha de apuesta realizada
  scene.fichaSeleccionadaValor = 10; // Valor de la ficha seleccionada para apostar
  scene.imagenFichaSeleccionada = null; // Imagen de la ficha seleccionada
  scene.fichasColocadas = []; // Stack de fichas colocadas (valores) para poder restar
  scene.ultimasFichasColocadas = []; // Copia del stack de la última apuesta (para repetir)
  scene.noVaMas = false; // Indica si no se aceptan movimiento de fichas

  scene.imagenesNumerosApuesta = []; // Arreglo que guarda las imagenes(números) de la Apuesta Total
  scene.imagenesNumerosPremio = []; // Arreglo que guarda las imagenes(números) del Premio Total

  scene.faseJuegoActual = 1; // Fase actual del juego (Armando apuesta)

  scene.indiceJugador = 1;
  scene.indiceManoJugador = 0;
  scene.indiceCartaManoJugador = 0;

  scene.indiceDealer = 0;
  scene.indiceManoDealer = 0;
  scene.indiceCartaManoDealer = 0;

  scene.puedeDividirMano = false;
  scene.puedeDoblarApuesta = true;
  scene.pagoSeguroRechazado = false; // Indica si el pago del seguro fue rechazado
  scene.pagoSeguroAceptado = false; // Indica si el pago del seguro fue aceptado

  // Split
  scene.esSplit = false; // Indica si la mano fue dividida
  scene.manoSplitActiva = 0; // Indice de la mano activa durante split (0 o 1)
  scene.indiceCartaMano2Jugador = 0; // Indice de la próxima carta a repartir en mano 2

  scene.imagenesValorMano1Jugador1Display = [];
  scene.imagenesValorMano2Jugador1Display = [];
  scene.imagenesValorManoDealerDisplay = [];
  scene.imagenesMontoSeguroDisplay = [];
  scene.imagenesMontoApuestaMano2Display = [];
  scene.imagenFichaSeguro = null; // Imagen de la ficha de seguro
}
